"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _segmentedButton = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/segmented-button.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _segmentedButton.default);
/** Group a series of buttons together on a single line with the segmented button.
 * Only one of the options can be active at a time, the others remain or become inactive.
 * The option can be activated by clicking on it.
 * This type of button is comparable to a radio button group. */

var ButtonSegmented = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "cssNamespace"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    "aria-label": "Group label",
    className: classnames("".concat(cssNamespace, "-segmented-button")),
    ref: ref,
    role: "group"
  }), children);
});

ButtonSegmented.displayName = 'ButtonSegmented';
ButtonSegmented.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node
};

var _default = (0, _withStyles.default)(ButtonSegmented);

exports.default = _default;